let host = "";
let ke_host = "";
if (process.env.NODE_ENV === "development") {
  // 开发环境
  // host = "https://tsuccess-cloud.successkaoyan.com/";
  ke_host = "https://lpc.successkaoyan.com:8080/";
  // 测试环境
  // host = "https://tsuccess-cloud.successkaoyan.com/";
  // ke_host = "https://tke.successkaoyan.com/";
  // 生成环境
  host = "https://success-cloud.successkaoyan.com/";
  // ke_host = "https://ke.successkaoyan.com/";
} else {
  // 测试环境
  // host = "https://tsuccess-cloud.successkaoyan.com/";
  // ke_host = "https://tke.successkaoyan.com/";
  // 生成环境
  host = "https://success-cloud.successkaoyan.com/";
  ke_host = "https://ke.successkaoyan.com/";
}
export { host, ke_host };
